module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-04-7df0b3a9f49ce6c7b510adf7fa107847.jpg";